// 菜单 顶栏
export const menuHeader = [

    {
        path: '/home',
        title: '首页',
        // 可使用font-awesome提供的图标
        icon: 'home',
        // isOnlyText 表示是否只显示文字模式，不显示图标
        isOnlyText: true
    },
    {
        path: '/resource',
        title: '云算力资源',
        // 可使用font-awesome提供的图标
        icon: 'home',
        // isOnlyText 表示是否只显示文字模式，不显示图标
        isOnlyText: true
    },
    {
        path: '/platform',
        title: '算力平台',
        // 可使用font-awesome提供的图标
        icon: 'home',
        // isOnlyText 表示是否只显示文字模式，不显示图标
        isOnlyText: true
    },
    {
        path: '/tech',
        title: 'AI算力技术',
        // 可使用font-awesome提供的图标
        icon: 'home',
        // isOnlyText 表示是否只显示文字模式，不显示图标
        isOnlyText: true
    },
    {
        path: '/solutions',
        title: '解决方案',
        // 可使用font-awesome提供的图标
        icon: 'home',
        // isOnlyText 表示是否只显示文字模式，不显示图标
        isOnlyText: true
    },
    // {
    //     path: '/hosting',
    //     title: '私有化部署',
    //     // 可使用font-awesome提供的图标
    //     icon: 'home',
    //     // isOnlyText 表示是否只显示文字模式，不显示图标
    //     isOnlyText: true
    // },
    // {
    //     path: '/resources',
    //     title: '资源中心',
    //     // 可使用font-awesome提供的图标
    //     icon: 'home',
    //     // isOnlyText 表示是否只显示文字模式，不显示图标
    //     isOnlyText: true
    // },
    {
        path: '/supports',
        title: '服务与支持',
        // 可使用font-awesome提供的图标
        icon: 'home',
        // isOnlyText 表示是否只显示文字模式，不显示图标
        isOnlyText: true
    },

    // {
    //     title: '系统管理',
    //     icon: 'cogs',
    //     children: [
    //         { path: '/system/user', title: '用户管理', isOnlyText: true },
    //         { path: '/system/role', title: '角色管理', isOnlyText: true },
    //         { path: '/system/menu', title: '菜单管理', isOnlyText: true },
    //         { path: '/system/app', title: '系统应用', isOnlyText: true },
    //         { path: '/system/login-log', title: '登录日志', isOnlyText: true },
    //         { path: '/system/operation-log', title: '操作日志', isOnlyText: true },
    //         { path: '/system/dic', title: '字典管理', isOnlyText: true },
    //         { path: '/system/pwd', title: '修改密码', isOnlyText: true }
    //         /*{ path: '/system/org', title: '组织机构管理-Test', isOnlyText: true },
    //         { path: '/system/dic', title: '字典管理-Test', isOnlyText: true },*/
    //     ]
    // },
    // {
    //     path: '/guoguan/information-publish',
    //     title: '建设中',
    //     icon: 'cube'
    // },
]

// 菜单 侧边栏
export const menuAside = menuHeader

/**
 * 应用商店角色菜单列表（预留变量）
 */
export const menuAppStore = [

]
/**
 * 分中心角色菜单列表（预留变量）
 */
export const menuCenterAppStore = [

]

/**
 * 用于应用商店角色登录后页面顶部的菜单（预留变量）
 */
export const headerMenuAppStore = []
/**
 * 用于分中心角色登录后页面顶部的菜单（预留变量）
 */
export const headerMenuCenterAppStore = []
